import { useState, useEffect, useContext } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import useFetchData from '../../hooks/useFetchData';
import useSort from '../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import Filter from '../Filter';
import { useNavigate } from 'react-router-dom';
import GlobalContext from 'contexts';

import globalTranslating from '../../translate.json';
import ClientTranslate from './translate.json';
// import '../style.scss';

const PredibetesWaitingDoctor = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...ClientTranslate };
  const [filteredclients, setFilteredclients] = useState([]);
  const { data: clientsData, loading } = useFetchData(
    'client-product/dashboard/predibitesWaitingDoctor'
  );
  const { productsList, organizationsList } = useContext(GlobalContext);

  useEffect(() => {
    if (clientsData?.length) setFilteredclients(clientsData);
  }, [clientsData]);

  const onFilter = (filteredData) => {
    setFilteredclients(filteredData);
  };

  const onResetFilters = () => {
    setFilteredclients(clientsData);
  };

  const { showFilters, toggle } = useSort();

  const actionsclientsList = [
    {
      icon: SortIcon,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredclients(clientsData);
        toggle(!showFilters);
      }
    }
  ];

  const tableHeaders = [
    translating.clientId,
    translating.fullName,
    translating.ssn,
    translating.phone,
    translating.organization,
    translating.createdDate
  ];

  const columns = [
    { value: 'id' },
    { value: 'clientFullName', sort: true, bold: true },
    { value: 'ssn' },
    { value: 'mobile' },
    { value: 'organizationName', sort: true },
    { value: 'productCreated', format: 'date', sort: true }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['clientFullName', 'ssn', 'mobile']
    },
    {
      type: 'select',
      label: translating.product,
      name: 'productId',
      options: productsList,
      isId: true
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'productCreated'
    },
    {
      type: 'date',
      subType: 'toDate',
      label: translating.toDate,
      name: 'toDate',
      field: 'productCreated'
    },
    {
      type: 'select',
      label: translating.organization,
      name: 'organizationId',
      options: organizationsList,
      isId: true
    }
  ];

  return (
    <div className="customers-list">
      <ListHeader
        title={translating.waitingDoctor}
        actions={actionsclientsList}
      ></ListHeader>
      {showFilters && productsList && organizationsList && (
        <Filter
          fields={sortFields}
          data={clientsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="customers-list-wrapper-table">
        {loading && <div>Loading</div>}
        {clientsData && !loading && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredclients}
            pagination={true}
            handleRowClick={(id) => {
              const client = filteredclients.find((f) => f.id === id);
              navigate(`/clients/${client.client_uuid}`);
            }}
          ></TablePagination>
        )}
      </div>
    </div>
  );
};

export default PredibetesWaitingDoctor;
